import AuthService from "../../utilities/accountAuth";
import { Fetch } from "../../utilities/misc";
import { customerFetch } from "../../utilities/customerFetch";
import { profile } from "../actionTypes";
import { store } from "../../store";
import { setProfile, clearProfile } from "../actions/account";
import { url } from "./settings";


type ProfileSuccessPayload = {
    success: boolean;
    data: {
        customer: profile
    }
}

type AuthSuccessPayload = {
    success: boolean;
    data: {
        token: string
    }
}

export const sendAuthCode = async (
    email: string, 
    recaptchaToken?: string|null, 
    redirect?: string,
    show_code_in_email?: boolean
) => {
    return await Fetch(`${url.account.auth.sendCode}`, {
        method: "POST",
        body: JSON.stringify({
            email,
            ...(redirect ? { redirect } : {}),
            ...(recaptchaToken ? { 'g-recaptcha-response': recaptchaToken } : {}),
            ...(show_code_in_email !== undefined ? { show_code_in_email } : {}),
        }),
    });
}

export const me = async () => {
    return await customerFetch(`${url.account.profile.me}`, {
        method: "GET"
    }).then(
        async (res) => {
            const payload: ProfileSuccessPayload = await res.json();
            return payload.data.customer
        },
        (error) => {
            throw error;
        }
    );
}

export const auth = async (email: string, code: string, recaptchaToken?: string|null) => {
    return await Fetch(`${url.account.auth.auth}`, {
        method: "POST",
        body: JSON.stringify({
            email,
            code,
            ...(recaptchaToken ? { 'g-recaptcha-response': recaptchaToken } : {}),
        }),
    }).then(
        async (res) => {
            const payload: AuthSuccessPayload = await res.json();
            AuthService.setAuthToken(payload.data.token);
            const profile = await me();
            store.dispatch(setProfile(profile));
            return profile;
        },
        (error) => {
            throw error;
        }
    );
}

export const googleAuth = async (googleToken: string) => {
    return await Fetch(`${url.account.auth.googleAuth}`, {
        method: "POST",
        body: JSON.stringify({
            'google_token': googleToken
        }),
    }).then(
        async (res) => {
            const payload: AuthSuccessPayload = await res.json();
            AuthService.setAuthToken(payload.data.token);
            const profile = await me();
            store.dispatch(setProfile(profile));
            return profile;
        },
        (error) => {
            throw error;
        }
    );
}

export const sendPhoneCode = async (phone: string) => {
    return await customerFetch(`${url.account.profile.sendPhoneCode}`, {
        method: "POST",
        body: JSON.stringify({ phone }),
    });
}

export const verifyPhone = async (phone: string, code: string) => {
    return await customerFetch(`${url.account.profile.verifyPhone}`, {
        method: "POST",
        body: JSON.stringify({ phone, code }),
    }).then(
        async (res) => {
            const payload: ProfileSuccessPayload = await res.json();
            store.dispatch(setProfile(payload.data.customer));
            return payload.data.customer;
        },
        (error) => {
            throw error;
        }
    );
}

export const getLastBooking = async () => {
    return await customerFetch(`${url.account.bookings}?limit=1&sort=desc`, {
        method: "GET"
    }).then(
        async (res) => {
            const payload = await res.json();
            return payload.data?.bookings && payload.data.bookings.length > 0 ? payload.data.bookings[0] : null;
        },
        (error) => {
            return null;
        }
    );
}

export const logout = async () => {
    try {
        await Fetch(`${url.account.auth.logout}`, {
            method: "POST",
            headers: AuthService.getAuthHeader()
        });
    } finally {
        AuthService.clearAuthToken();
        store.dispatch(clearProfile());
    }
}
